import { Coord } from "../types/Interface";

export default function getDistanceBtwPoints(coord1: Coord, coord2: Coord) {
  return Math.sqrt(Math.pow(coord1.x - coord2.x, 2) + Math.pow(coord1.y - coord2.y, 2));
}